// src/pages/AllProducts.jsx
import React, { useEffect, useMemo, useState, useCallback } from "react";
import "./AllProducts.css";
import { useNavigate , useLocation} from "react-router-dom";

import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { MdInfoOutline } from "react-icons/md";
import { FaWhatsapp} from "react-icons/fa";


/* Firestore */
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  startAfter,
  doc,
  getDoc,
  documentId,
} from "firebase/firestore";

/* Cart */
import { useCart } from "../CartProvider";
import ModalDetail from "../components/ModalDetail";

/* ====== Normalisation produit (adapte les champs si besoin) ====== */
const COLUMN_MAP = {
  idField: "id", // sinon doc.id
  titleField: "Name",
  categoryField: "category",
  imageField: "ImageUrl",
  priceField: "price",
  oldPriceField: "oldPrice",
  stockField: "QuantityAvailable",
};

function normalize(docSnap) {
  const d = docSnap.data();
  return {
    id: d?.[COLUMN_MAP.idField] ?? docSnap.id,
    title: d?.[COLUMN_MAP.titleField] ?? "Untitled",
    category: d?.[COLUMN_MAP.categoryField] ?? "",
    image: d?.[COLUMN_MAP.imageField] ?? "",
    price: Number(d?.Stores?.Cassablanca?.SalePrice ?? 0),
    oldPrice: Number(d?.[COLUMN_MAP.oldPriceField] ?? 0),
    stock: Number(
    Number(d?.Stores?.Cassablanca?.Quantity ?? 0) +
    Number(d?.Stores?.Dekon?.Quantity ?? 0) +
    Number(d?.Stores?.Baguida?.Quantity ?? 0)
  ) ,
    InShip: Number(d?.QuantityInPo ?? 0) + Number(d?.QuantityInShpping ?? 0),
    IsPack: Boolean(d?.HasChilds ?? false),
    parentId: d?.ParentId ?? null,
    Images: d?.Images ?? [],
    Description: d?.Description ?? "Pas de description...",
    SubCategorie: d?.Categorie?.SubCategorie?.Id ?? null,
    ParentId: (d?.ParentId == null || String(d.ParentId).trim() === '') ? docSnap.id : d.ParentId ,
    MaxiDiscount: Number(d?.MaxiDiscount ?? 0),
    GetDiscount: Boolean(d?.GetDiscount ?? false),
    ApplyInvitation: Boolean(d?.ApplyInvitation ?? false),
  };
}

const groupSort = (arr) => {
  return [...arr].sort((a, b) => {
    // 1) Grouper par ParentId (même groupe = parent + ses enfants)
    if (a.ParentId < b.ParentId) return -1;
    if (a.ParentId > b.ParentId) return 1;

    // 2) Dans un groupe, le parent d'abord
    const aIsParent = a.id === a.ParentId;
    const bIsParent = b.id === b.ParentId;
    if (aIsParent !== bIsParent) return aIsParent ? -1 : 1;

    // 3) Départage stable
    return String(a.title || "").localeCompare(String(b.title || ""));
  });
};


const PAGE_SIZE = 24;
const MAX_FETCH_LOOPS = 5; // garde-fou: max 5 lectures Firestore par appel de loadPage (donc 120 docs lus max), pour éviter une explosion des coûts si beaucoup de produits sont en rupture

const formatFCFA = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Number(n || 0));

export default function AllProducts() {

  const [filtersOpen, setFiltersOpen] = useState(false);

// optionnel: empêcher le scroll quand ouvert
useEffect(() => {
  document.body.style.overflow = filtersOpen ? "hidden" : "";
  return () => (document.body.style.overflow = "");
}, [filtersOpen]);

useEffect(() => {
        document.title = "Tout ce dont vous avez besoin !!!";
      }, []);


  const navigate = useNavigate();

  /* ====== Cart (B2-like) ====== */
  const { cart, addToCart, inc, dec } = useCart();

  /* ====== Sélection catégorie ====== */
  // { type: 'parent'|'child', id: string, label: string } | null
  const [selectedCat, setSelectedCat] = useState({ type: "child", id: "peFtnecRWwizMp2Piwg9E", label: "Protein & Supplements" });

  /* ====== Catégories Firestore ====== */
  const [parents, setParents] = useState([]); // [{id,label,children:[{id,label}]}]
  const [expanded, setExpanded] = useState(new Set());
  const [catLoading, setCatLoading] = useState(true);
  const [catErr, setCatErr] = useState("");

  /* ====== Produits paginés ====== */
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null); // last doc
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [myData , setMyData] = useState([]);


  const { state } = useLocation();
  const [itemLink, setItemLink] = useState(state?.myLink || null);

  // useEffect(() => {
  //   if(itemLink !== null){
  //     setSelectedCat({ type: "child", id: itemLink, label: "Autres" });
  //   }
  //   else{
  //     setSelectedCat({ type: "child", id: "peFtnecRWwizMp2Piwg9E", label: "Protein & Supplements" });
  //   }
  // } , [itemLink]);

  /* -------- Charger catégories (parents -> enfants) -------- */
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setCatLoading(true);
        setCatErr("");
        const snap = await getDoc(doc(db, "categories", "list"));
        if (!mounted) return;

        if (!snap.exists()) {
          setParents([]);
          return;
        }
        const raw = snap.data()?.data ?? [];

        const norm = raw
          .map((p) => ({
            id: p?.id ?? p?.label ?? Math.random().toString(36),
            label: String(p?.label ?? "").trim(),
            children: Array.isArray(p?.children)
              ? p.children
                  .map((c) => ({
                    id: c?.id ?? c?.label ?? Math.random().toString(36),
                    label: String(c?.label ?? "").trim(),
                  }))
                  .filter((c) => c.label)
              : [],
          }))
          .filter((p) => p.label);

        setParents(norm);
      } catch (e) {
        console.error(e);
        setCatErr("Impossible de charger les catégories.");
      } finally {
        if (mounted) setCatLoading(false);
      }
    })();
    return () => (mounted = false);
  }, []);

  const toggleExpand = (id) =>
    setExpanded((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  /* -------- Construire la requête Firestore selon sélection -------- */
  const buildQuery = useCallback(
  (afterDoc = null) => {
    const col = collection(db, "items");

    // CAS 1: si itemLink existe
    if (itemLink) {
      const parts = [
        where("Categorie.SubCategorie.Id", "==", itemLink),
        where("IsProductValidated", "==", true),
        orderBy(documentId()),
        limit(PAGE_SIZE),
      ];
      if (afterDoc) parts.push(startAfter(afterDoc));
      return query(col, ...parts);
    }

    // CAS 2: aucune catégorie cochée → produits validés
    if (!selectedCat) {
      const parts = [where("IsProductValidated", "==", true), limit(PAGE_SIZE)];
      if (afterDoc) parts.push(startAfter(afterDoc));
      return query(col, ...parts);
    }

    // CAS 3: catégorie parent cochée
    if (selectedCat.type === "parent") {
      const parts = [
        where("Categorie.Id", "==", selectedCat.id),
        where("IsProductValidated", "==", true),
        orderBy(documentId()),
        limit(PAGE_SIZE),
      ];
      if (afterDoc) parts.push(startAfter(afterDoc));
      return query(col, ...parts);
    }

    // CAS 4: sous-catégorie cochée
    const parts = [
      where("Categorie.SubCategorie.Id", "==", selectedCat.id),
      where("IsProductValidated", "==", true),
      orderBy(documentId()),
      limit(PAGE_SIZE),
    ];
    if (afterDoc) parts.push(startAfter(afterDoc));
    return query(col, ...parts);
  },
  [selectedCat, itemLink]
);


  /* -------- Charger une page (en ne gardant que les produits en stock) -------- */
  const loadPage = useCallback(
    async (append = false) => {
      try {
        setLoading(true);
        setErr("");

        let localCursor = append ? cursor : null;
        let collected = [];
        let exhausted = false; // true = plus aucun document à lire dans Firestore pour cette requête
        let loops = 0;

        // On lit des lots successifs depuis Firestore (via le curseur) jusqu'à
        // réunir PAGE_SIZE produits EN STOCK, ou jusqu'à épuiser la collection,
        // ou jusqu'à atteindre le plafond de sécurité MAX_FETCH_LOOPS.
        while (collected.length < PAGE_SIZE && loops < MAX_FETCH_LOOPS) {
          const q = buildQuery(localCursor);
          const snap = await getDocs(q);

          if (snap.empty) {
            exhausted = true;
            break;
          }

          const docs = snap.docs.map((d) => normalize(d));
          const inStockDocs = docs.filter((p) => p.stock > 0);

          collected = collected.concat(inStockDocs);
          localCursor = snap.docs[snap.docs.length - 1];
          loops += 1;

          if (snap.docs.length < PAGE_SIZE) {
            // dernière page Firestore atteinte pour cette requête
            exhausted = true;
            break;
          }
        }

        const newSorted = groupSort(collected.slice(0, PAGE_SIZE));

        setItems((prev) => (append ? [...prev, ...newSorted] : newSorted));
        setCursor(localCursor);
        setHasMore(!exhausted);
      } catch (e) {
        console.error(e);
        setErr("Impossible de charger les produits.");
      } finally {
        setLoading(false);
      }
    },
    [buildQuery, cursor]
  );

  /* -------- (Re)chargement sur changement de filtre -------- */
  useEffect(() => {
    setItems([]);
    setCursor(null);
    setHasMore(true);
    loadPage(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    window.scrollTo({
  top: 0,
  behavior: 'smooth'
});
  }, [selectedCat]);

  const handleDetails = (item) => navigate(`/details/${item.id}`, { state: { item } });

  /* -------- Affichage -------- */
  const content = useMemo(() => {
    if (err) return <p className="all-error-all">{err}</p>;

    return (
      <>
      <p style={{ textAlign:'left' , fontSize: 22 , color: "#111" , fontWeight:'bold'}}>{items.length} Resultats</p>
      <div className="all-grid-all">
        
        {items.map((p, i) => {
          const qty = cart[p.id]?.qty ?? 0;
          const inCart = qty > 0;

          return (
            <article className="all-card-all" key={`${p.id}-${i}`}>
              <div className="all-media-all">
                <img
                  src={p.image || "https://via.placeholder.com/800x600?text=No+image"}
                  alt={p.title}
                  loading="lazy"
                  onClick={() => handleDetails(p)}
                />
                {p.IsPack === true && <span className="all-badge-all">Paquet</span>}
                {p.parentId ? <span className="all-badge-all">Detail</span> : null}
                <button 
                className="all-like-all" 
                aria-label="Wishlist" 
                onClick={(e) => {
                  e.stopPropagation(); // empêche le clic de remonter jusqu'à l'image
                  setMyData(p);
                  setIsOpen(true);
                }}
                >
                  <MdInfoOutline size={14} aria-hidden="true" />
                </button>
              </div>

              <div className="all-body-all">
                <p className="all-titlecard-all" title={p.title}>{p.title}</p>

                <div className="all-stock-all">
                  <span className="all-price-all">{formatFCFA(p.price)} FCFA</span>
                  {!!p.oldPrice && (
                    <span className="all-oldprice-all">
                      {formatFCFA(p.oldPrice.toLocaleString("fr-FR"))} FCFA
                    </span>
                  )}
                </div>

                {/* CTA zone — comportement B2 */}
                {!inCart ? (
                  p.stock > 0
                  ?
                  <button className="all-add-all" onClick={() => addToCart(p.id, p)}>
                    <span className="all-cartico-all" aria-hidden="true">+</span>
                    Add to Cart
                  </button>
                  :
                  <button className="all-add-all" onClick={() => { setMyData(p); setIsOpen(true)}}>
                    <span  aria-hidden="true"><FaWhatsapp size={20} /></span>
                    Whatsapp
                  </button>
                ) : (
                  <>
                    <div className="qty-wrap-pl">
                      <span className="qty-label-pl">Quantité</span>
                      <div className="qty-ctrl-pl">
                        <button onClick={() => dec(p.id)} aria-label="Decrease">−</button>
                        <span>{qty}</span>
                        <button onClick={() => inc(p.id, p.stock)} aria-label="Increase">+</button>
                      </div>
                    </div>

                    <div className="subtotal-pl">
                      <span>{window.innerWidth >= 600 ? "Sous total" : "Total"}</span>
                      <strong >
                        {formatFCFA((qty * Number(p.price)))} FCFA
                      </strong>
                    </div>
                  </>
                )}
              </div>
            </article>
          );
        })}

        {/* Squelettes pendant chargement */}
        {loading &&
          Array.from({ length: 6 }).map((_, k) => (
            <article key={`sk-${k}`} className="all-card-all" aria-busy="true">
              <div className="all-media-all" style={{ background: "#f3f4f6" }} />
              <div className="all-body-all">
                <div className="all-titlecard-all" style={{ background: "#f3f4f6", height: 16 }} />
                <div className="all-pricewrap-all" style={{ background: "#f3f4f6", height: 14 }} />
                <button className="all-add-all" disabled>Chargement...</button>
              </div>
            </article>
          ))}
      </div>
      </>
    );
  }, [items, cart, loading, err, addToCart, inc, dec]);

  return (
    <>
      <NavBar />
      <section className="all-wrap-all">
        <h2 className="all-title-all">{selectedCat?.label}</h2>

        {/* bouton mobile */}
        <div className="all-mobilebar-all">
          <button
            className="all-filterbtn-all"
            onClick={() => setFiltersOpen(true)}
          >
            Filtrer
          </button>
        </div>

        <div className="all-layout-all">
          {filtersOpen && (
            <div
              className="filters-overlay-all"
              onClick={() => setFiltersOpen(false)}
              aria-hidden
            />
          )}
          {/* Sidebar */}
          <aside className={`all-sidebar-all ${filtersOpen ? "open" : ""}`}>
            <div className="all-filterbar-head">
              <h6 className="all-blocktitle-all"></h6>
              
              {
              window.innerWidth <= 900 ?
              <button
                className="all-closefilter-all"
                onClick={() => setFiltersOpen(false)}
                aria-label="Fermer les filtres"
              >
                ×
              </button>
              :
              ''
              }
            </div>
            <div className="all-block-all">
              <h6 className="all-blocktitle-all">Nos Categories</h6>

              {catLoading && <div className="all-loading-all">Loading…</div>}
              {catErr && <div className="all-error-all">{catErr}</div>}

              {!catLoading && !catErr && (
                <div className="all-accordion-all">
                  <button
                    className="all-clearcat-all"
                    onClick={() => setSelectedCat({ type: "child", id: "peFtnecRWwizMp2Piwg9E", label: "Protein & Supplements" })}
                    disabled={!selectedCat}
                    title="Reset category"
                  >
                    Clear selection
                  </button>

                  {parents.map((p) => {
                    const isOpen = expanded.has(p.id);
                    const isParentChecked =
                      selectedCat?.type === "parent" && selectedCat?.id === p.id;

                    return (
                      <div key={p.id} className="all-acc-parent-all">
                        <div className="all-acc-header-all">
                          <label className="all-acc-checklabel-all">
                            <input
                              type="radio"
                              name="cat-radio"
                              checked={!!isParentChecked}
                              onChange={() => {
                                setSelectedCat(
                                  isParentChecked ? null : { type: "parent", id: p.id, label: p.label }
                                ) ; setItemLink(null);
                                if (window.innerWidth <= 900) setFiltersOpen(false);
                              }
                              }
                              // onChange={() => {
                              //   setSelectedCat(isParentChecked ? null : { type: "parent", id: p.id, label: p.label });
                              //   if (window.innerWidth <= 900) setFiltersOpen(false);
                              // }}

                            />
                            <span className="all-parentlabel-all">{p.label}</span>
                          </label>

                          <button
                            type="button"
                            className={`all-caret-all ${isOpen ? "open" : ""}`}
                            aria-expanded={isOpen}
                            aria-label={`Toggle ${p.label}`}
                            onClick={() => toggleExpand(p.id)}
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" />
                            </svg>
                          </button>
                        </div>

                        {isOpen && p.children.length > 0 && (
                          <ul className="all-acc-children-all">
                            {p.children.map((c) => {
                              const isChildChecked =
                                selectedCat?.type === "child" && selectedCat?.id === c.id;
                              return (
                                <li key={c.id}>
                                  <label>
                                    <input
                                      type="radio"
                                      name="cat-radio"
                                      checked={!!isChildChecked}
                                      onChange={() => {
                                        setSelectedCat(
                                          isChildChecked ? null : { type: "child", id: c.id, label: c.label }
                                        ) ; setItemLink(null);
                                        if (window.innerWidth <= 900) setFiltersOpen(false);
                                      }
                                      }
                                      // onChange={() => {
                                      //   setSelectedCat(isParentChecked ? null : { type: "child", id: p.id, label: p.label });
                                      //   if (window.innerWidth <= 900) setFiltersOpen(false);
                                      // }}

                                    />
                                    <span>{c.label}</span>
                                  </label>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </aside>

          {/* Grid produits */}
          <main className="all-products-all">
            {content}

            {/* Pagination en bas */}
            <div className="all-pager-all">
              <button
                className="all-loadmore-all"
                onClick={() => loadPage(true)}
                disabled={loading || !hasMore}
              >
                {hasMore ? (loading ? "Chargement..." : "Afficher Plus") : "Oups, Aucun produit dans cette catégorie !!!"}
              </button>
            </div>
          </main>
        </div>
      </section>

      <ModalDetail isOpen={isOpen} onClose={() => setIsOpen(false)} myProducts={myData}/>
      <Footer />
    </>
  );
}